import useAlertStatus from './useAlertStatus';

export default function useShowOutOfAreaError(): boolean {
  const { notAvailableInCA, outOfMarket, outOfMarketNewCar } = useAlertStatus();

  return notAvailableInCA || outOfMarket || outOfMarketNewCar;
}
